export const myDocumentsUserListTableDef = {
  id: "my-documents-user-list-table-def",
  select: "row",
  columns: [
    {
      id: "avatar",
      type: "avatar",
      label: "OC_IMAGE",
      align: "center",
      width: "85px",
    },
    {
      id: "name",
      type: "pipedName",
      label: "OC_NAME",
      sort: true,
      search: true,
    },
    {
      id: "orgUnit",
      type: "text",
      label: "OC_ORGUNIT",
      sort: true,
      search: true,
    },
    {
      id: "jobClass",
      type: "text",
      label: "MY_HR_JOB_CLASS",
      sort: true,
    },
  ],
};

export const myDocumentsUserListMobileTableDef = {
  id: "my-documents-user-list-mobile-table-def",
  select: "row",
  columns: [
    {
      id: "avatar",
      type: "avatar",
      label: "OC_IMAGE",
      align: "center",
      width: "85px",
    },
    {
      id: "name",
      type: "pipedName",
      label: "OC_NAME",
      sort: true,
      search: true,
    },
    {
      id: "actionArrow",
      type: "actionArrow",
      label: "",
      align: "center",
      width: "40px",
    },
  ],
};

export const myDocumentsDocumentListTableDef = {
  id: "my-documents-document-list-table-def",
  select: "row",
  columns: [
    {
      id: "actionArrow",
      type: "actionArrow",
      label: "",
      align: "center",
      width: "40px",
    },
    {
      id: "description",
      type: "designation",
      label: "OC_DESIGNATION",
      align: "left",
    },
    {
      id: "filename",
      type: "filename",
      label: "MY_DOCUMENTS_FILE_NAME",
    },
    {
      id: "uploaded",
      type: "uploaded",
      label: "MY_DOCUMENTS_UPLOADED",
    },
    {
      id: "actionButton",
      type: "actionButton",
      label: "",
      align: "right",
      width: "70px",
    },
  ],
};

export const myDocumentsDocumentListMobileTableDef = {
  id: "my-documents-document-list-mobile-table-def",
  select: "row",
  columns: [
    {
      id: "description",
      type: "designation",
      label: "OC_DESIGNATION",
      align: "left",
    },
    {
      id: "uploaded",
      type: "uploaded",
      label: "MY_DOCUMENTS_UPLOADED",
    },
    {
      id: "actionArrow",
      type: "actionArrow",
      label: "",
      align: "center",
      width: "40px",
    },
  ],
};

export const massUploadHistoryTableDef = {
  id: "mass-upload-history-table-def",
  select: "row",
  columns: [
    {
      id: "actionArrow",
      type: "actionArrow",
      label: "",
      align: "center",
      width: "40px",
    },
    {
      id: "avatar",
      type: "avatar",
      label: "OC_IMAGE",
      align: "center",
      width: "85px",
    },
    {
      id: "name",
      type: "pipedName",
      label: "MY_DOCUMENTS_UPLOADER",
    },
    {
      id: "orgUnit",
      type: "text",
      label: "OC_ORGUNIT",
    },
    {
      id: "uploadedAt",
      type: "text",
      label: "MY_DOCUMENTS_UPLOADED_AT",
    },
    {
      id: "documentCount",
      type: "text",
      label: "MY_DOCUMENTS_FILE_COUNT",
      align: "center",
      width: "100px",
    },
  ],
};

export const massUploadHistoryMobileTableDef = {
  id: "mass-upload-history-mobile-table-def",
  select: "row",
  columns: [
    {
      id: "avatar",
      type: "avatar",
      label: "OC_IMAGE",
      align: "center",
      width: "85px",
    },
    {
      id: "name",
      type: "pipedName",
      label: "MY_DOCUMENTS_UPLOADER",
    },
    {
      id: "actionArrow",
      type: "actionArrow",
      label: "",
      align: "center",
      width: "40px",
    },
  ],
};
